<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.userName">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ $store.getters.userDisplayName }}</p>
      <small v-text="$store.getters.userRole">دانش آموز</small>
    </div>


    <div @click="visible=!visible" class="con-img ml-3">
      <img v-if="activeUserInfo.photoURL" key="onlineImg" :src="activeUserInfo.photoURL" alt="user-img" width="40"
           height="40" class="rounded-full shadow-md cursor-pointer block"/>
      <img v-else :src="require('@/assets/images/avatar.png')" alt="user-img" width="40" height="40"
           class="rounded-full shadow-md cursor-pointer block"/>
    </div>


    <div class="custom-navbar-dropdown">
      <ul v-show="visible" style="min-width: 9rem">
        <router-link class="text-dark" to="/profile">
          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4"/>
            <span class="ml-2">پروفایل</span>
          </li>
        </router-link>

        <!--          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">-->
        <!--            <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />-->
        <!--            <span class="ml-2">Inbox</span>-->
        <!--          </li>-->

        <!--          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">-->
        <!--            <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />-->
        <!--            <span class="ml-2">Tasks</span>-->
        <!--          </li>-->

        <!--          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">-->
        <!--            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />-->
        <!--            <span class="ml-2">Chat</span>-->
        <!--          </li>-->

        <!--          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">-->
        <!--            <feather-icon icon="HeartIcon" svgClasses="w-4 h-4" />-->
        <!--            <span class="ml-2">Wish List</span>-->
        <!--          </li>-->

        <vs-divider class="m-1"/>
        <li
          class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
          @click="logout">
          <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"/>
          <span class="ml-2">خروج</span>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
  export default {
    created() {
      let self = this;
      window.addEventListener('click', e => {
        if (!self.$el.contains(e.target)) {
          self.visible = false
        }
      })
    },
    data() {
      return {
        visible: false
      }
    },
    computed: {
      activeUserInfo() {
        return this.$store.state.AppActiveUser
      }
    },
    methods: {
      logout() {
        this.$store.commit('LOG_OUT');
        this.$router.push('/login').catch(() => {
        })
      },
    }
  }
</script>

<style scoped>
  .custom-navbar-dropdown {
    position: fixed;
    right: 10px;
    top: 60px;
    background-color: white;
    border-radius: 3px;
    box-shadow: 0 5px 25px 0 rgba(0, 0, 0, .1);
    border: 1px solid rgba(0, 0, 0, .1);
  }
</style>
